import script from "./TaskDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskDescription.vue?vue&type=script&lang=ts&setup=true"

import "./TaskDescription.vue?vue&type=style&index=0&id=110535a6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110535a6"]])

export default __exports__